import forEach from './iterate';



export default (element) => {
  forEach(element, (element) => {
    element.parentNode.removeChild(element);
  });
};



// WEBPACK FOOTER //
// ./src/lib/dom/element-remove.js